import { INITIAL_PATH } from '@/constants';

export const composeRootPath = (path: string): string => INITIAL_PATH + path;
